import React from "react";
import Layout from "../components/Layout";
import EmbedVideoItem from "../components/EmbedVideoItem";
import embedVideoData from "../json/embedVideoData";
import "../css/App.css";

export default function Video() {
  return (
    <Layout>
      <section className="video">
        <div className="video__hero">
          <div className="iframe--wrap">
            <iframe
              className="iframe"
              src="https://www.youtube.com/embed/UQjNbgBkpTE"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Videobook"
            ></iframe>
          </div>
        </div>
        <div className="video-feed">
          {embedVideoData.map((video) => {
            return (
              <EmbedVideoItem
                url={video.url}
                key={video.id}
                title={video.title}
                description={video.description}
                details={video.details}
              />
            );
          })}
        </div>
      </section>
    </Layout>
  );
}
